import fetch from 'isomorphic-fetch';
import moment from 'moment';


import { API_ROOT } from '../../api-config';
import { fetch_options } from '../utils';

import { ERROR } from '../user';
import { AClass } from '../../models/aclass';

export const CREATE_CLASS = 'classes/CREATE_CLASS';
export const LOAD_CLASS = 'classes/LOAD_CLASS';
export const RECEIVED_CLASSES = 'classes/RECEIVED_CLASSES';
export const RECEIVED_CLASS = 'classes/RECEIVED_CLASS';
export const RESET_CURRENT = 'classes/RESET_CURRENT';
export const DELETED_CLASS = 'classes/DELETED_CLASS';
export const RECEIVED_STUDENT = 'classes/RECEIVED_STUDENT';

const initialState = {
  current: null,
  data: null,
  isFetching: false,
  lastUpdated: null,
  error: null
};

export default (state: any = initialState, action: any) => {
  switch (action.type) {
    case CREATE_CLASS:
      return {
        ...state,
        current: null,
        isFetching: true
      };

    case LOAD_CLASS:
      return {
        ...state,
        current: null,
        isFetching: true
      };

    case RECEIVED_CLASSES:
      return {
        ...state,
        isFetching: false,
        current: null,
        data: action.aClass,
        lastUpdated: moment()
      };

    case RECEIVED_CLASS:
      const classIndex = state.data ? state.data.findIndex((c: AClass) => c.id === action.aClass.id) : -1;
      const updatedData = state.data ? [...state.data] : [];
      if (classIndex >= 0) {
        updatedData[classIndex] = action.aClass;
      } else updatedData.push(action.aClass);
      updatedData.sort((a: AClass, b: AClass) => b.id - a.id);
      return {
        ...state,
        isFetching: false,
        current: action.aClass,
        data: updatedData,
        lastUpdated: moment()
      };

    case RESET_CURRENT:
      return {
        ...state,
        current: null,
        isFetching: false
      };

    case DELETED_CLASS:
      const filteredData = state.data ? state.data.filter((c: AClass) => c.id !== action.cid) : null;
      return {
        ...state,
        isFetching: false,
        current: null,
        data: filteredData,
        lastUpdated: moment()
      };

    case RECEIVED_STUDENT:
      const currentStudents = state.current && state.current.students ? state.current.students : [];
      const foundIndex = currentStudents.findIndex(aS => aS.uid == action.student.uid);

      if (foundIndex < 0) currentStudents.push(action.student);
      else currentStudents[foundIndex] = action.student;

      const updatedCurrent = state.current ? { ...state.current, students: currentStudents } : null;

      return {
        ...state,
        isFetching: false,
        current: updatedCurrent,
        lastUpdated: moment()
      };

    default:
      return state;
  }
};

export function loadUserClasses(uid: number) {

  return function (dispatch) {
    dispatch({
      type: LOAD_CLASS
    });

    const url = `${API_ROOT}/classes/findbyuser/${uid}`;

    return fetch(url, fetch_options)
      .then(response => {
        if (response.ok) return response.json();
        else if (response.status == 404) return null;
        else throw new Error(response);
      })
      .then(aClass => {
        // console.log('loadUserClasses received:', aClass);

        dispatch({
          type: RECEIVED_CLASSES,
          aClass: aClass,
          receivedAt: Date.now()
        });

      })
      .catch(error => {
        console.error('loadUserClasses error fetching:', error);
        dispatch({
          type: ERROR,
          error: 'An error ocurred'
        });
      });
  };
}

export function createAClass(aClass: AClass) {

  return function (dispatch) {
    dispatch({
      type: CREATE_CLASS
    });

    const url = `${API_ROOT}/classes`;
    const _fetch_options = {
      ...fetch_options,
      method: "POST",
      body: JSON.stringify(aClass)
    };

    return fetch(url, _fetch_options)
      .then(response => {
        if (response.ok) return response.json();
        else throw new Error(response);
      })
      .then(aClass => {
        // console.log('createAClass received:', aClass);

        dispatch({
          type: RECEIVED_CLASS,
          aClass: aClass,
          receivedAt: Date.now()
        });

      })
      .catch(error => {
        console.error('createAClass error fetching:', error);
        dispatch({
          type: ERROR,
          error: 'An error ocurred'
        });
      });
  };
}

export function loadAClass(classId: number) {

  return function (dispatch) {
    dispatch({
      type: LOAD_CLASS
    });

    const url = `${API_ROOT}/classes/${classId}`;
    return fetch(url, fetch_options)
      .then(response => {
        if (response.ok) return response.json();
        else throw new Error(response);
      })
      .then(aClass => {
        // console.log('loadClass received:', aClass);

        dispatch({
          type: RECEIVED_CLASS,
          aClass: aClass,
          receivedAt: Date.now()
        });

      })
      .catch(error => {
        console.error('loadAClass error fetching:', error);
        dispatch({
          type: ERROR,
          error: 'An error ocurred'
        });
      });
  };
}

export const resetCurrent = () => {
  return dispatch => {
    dispatch({
      type: RESET_CURRENT
    });
  };
};

export function deleteUserClass(uid: number, cid: number) {

  return function (dispatch) {
    dispatch({
      type: LOAD_CLASS
    });

    const url = `${API_ROOT}/classes/delete/${uid}/${cid}`;

    const _fetch_options = {
      ...fetch_options,
      method: "DELETE",
    };

    return fetch(url, _fetch_options)
      .then(response => {
        if (response.ok) return response.json();
        else throw new Error(response);
      })
      .then(response => {
        // console.log('deleteUserClass received:', response);

        dispatch({
          type: DELETED_CLASS,
          cid: cid,
        });

      })
      .catch(error => {
        console.error('deleteUserClass error fetching:', error);
        dispatch({
          type: ERROR,
          error: 'An error ocurred'
        });
      });
  };
}